// Simulation event definitions for stage tracking and funnel analysis.

import type { EventDefinition } from './navigation';

export type SimulationStageEnteredProperties = {
  stage: number;
  stageName: string;
};

export type SimulationCompletedProperties = {
  totalDurationMs: number;
  stagesVisited: number;
};

export type SimulationAbandonedProperties = {
  lastStage: number;
  lastStageName: string;
};

export const SIMULATION_STAGE_ENTERED: EventDefinition<SimulationStageEnteredProperties> = {
  name: 'simulation_stage_entered',
};

export const SIMULATION_COMPLETED: EventDefinition<SimulationCompletedProperties> = {
  name: 'simulation_completed',
};

export const SIMULATION_ABANDONED: EventDefinition<SimulationAbandonedProperties> = {
  name: 'simulation_abandoned',
};
